import TableModule from "components/Modules/Collections/TableModule"
import {
  createFirestoreDocument,
  getDataFromFirestoreCollection,
} from "helpers/Firestore"
import React from "react"

const CityPartnersTable = () => {
  return (
    <TableModule
      getData={async ({ firebaseUID }) => {
        return await getDataFromFirestoreCollection({
          path: `City/Business/Partners`,
          where: [
            {
              key: "Cities",
              operation: "array-contains",
              value: firebaseUID,
            },
          ],
        })
      }}
      columns={[{ key: "Title", label: "Title" }]}
      searchKey={"Title"}
    />
  )
}

export default CityPartnersTable
